import {openResourceModal} from '../../core/modalCommand';
import {
	GUEST_PLAN_CREATE_MODAL_EVENT,
	GUEST_PLAN_DELETE_MODAL_EVENT,
	GUEST_PLAN_EDIT_MODAL_EVENT,
} from './events';

/**
 * Open the Add Guest Access Plan form.
 * @param {object} command modal command
 * @param {object} envelope command envelope
 * @return {Promise<object>} completion
 */
export function openGuestPlanCreateModal(command, envelope) {
	return openResourceModal(GUEST_PLAN_CREATE_MODAL_EVENT, command, envelope);
}

/**
 * Open a guest access plan's Edit form.
 * @param {object} command modal command
 * @param {object} envelope command envelope
 * @return {Promise<object>} completion
 */
export function openGuestPlanEditModal(command, envelope) {
	return openResourceModal(GUEST_PLAN_EDIT_MODAL_EVENT, command, envelope);
}

/**
 * Open a guest access plan's Delete confirmation.
 * @param {object} command modal command
 * @param {object} envelope command envelope
 * @return {Promise<object>} completion
 */
export function openGuestPlanDeleteModal(command, envelope) {
	return openResourceModal(GUEST_PLAN_DELETE_MODAL_EVENT, command, envelope);
}
